import React from 'react';

import { EmployerStaffsListQueryVariables, useEmployerStaffsListQuery } from 'src/api';

export const useEmployerStaffsList = (
  variables?: EmployerStaffsListQueryVariables,
  skip?: boolean,
  notifyOnNetworkStatusChange?: boolean,
) => {
  const { data, loading, refetch } = useEmployerStaffsListQuery({
    variables,
    skip,
    notifyOnNetworkStatusChange,
  });

  const employerStaffsList = React.useMemo(
    () => data?.employerStaffList ?? [],
    [data?.employerStaffList],
  );

  const employerStaffsCount = React.useMemo(
    () => data?.employerStaffCount ?? 0,
    [data?.employerStaffCount],
  );

  return {
    employerStaffsList,
    employerStaffsCount,
    refetch,
    loading,
  };
};
